import { render, staticRenderFns } from "./DocumentsList.vue?vue&type=template&id=3a59471f&scoped=true&"
import script from "./DocumentsList.vue?vue&type=script&lang=js&"
export * from "./DocumentsList.vue?vue&type=script&lang=js&"
import style0 from "./DocumentsList.vue?vue&type=style&index=0&id=3a59471f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a59471f",
  null
  
)

export default component.exports